import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-h3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-h5" }, "El ganador del sorteo es: ", -1)
const _hoisted_3 = { class: "text-h2" }

import { ref, watch, onBeforeUnmount } from "vue";
import confetti from "canvas-confetti";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSorteoSuccess',
  props: {
    isVisible: { type: Boolean },
    message: {}
  },
  emits: ["update:isVisible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const internalIsVisible = ref<boolean>(props.isVisible);
const countdown = ref<number>(5);
let countdownInterval: ReturnType<typeof setInterval> | null = null;

const emit = __emit;

const close = () => {
  emit("update:isVisible", false);
  internalIsVisible.value = false;
};

const startConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
  });
};

const startCountdown = () => {
  countdown.value = 5;
  countdownInterval = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value -= 1;
    } else {
      if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = null;
        startConfetti();
      }
    }
  }, 1000);
};

watch(
  () => props.isVisible,
  (newVal) => {
    internalIsVisible.value = newVal;
    if (newVal) {
      startCountdown();
    }
  }
);

onBeforeUnmount(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalIsVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalIsVisible).value = $event)),
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "purple",
                icon: "mdi-dice-6"
              }),
              _createTextVNode(" Éxito "),
              _createVNode(_component_v_icon, {
                color: "purple",
                icon: "mdi-dice-6"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, { class: "my-3" }),
          _createVNode(_component_v_card_text, { class: "text-center" }, {
            default: _withCtx(() => [
              (countdown.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(countdown.value) + "...", 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_2,
                    _createElementVNode("span", _hoisted_3, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.message), 1)
                    ])
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "blue darken-1",
                variant: "tonal",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OK")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})